
import TitlePages from '../components/TitlePages'
import CardInfo from '../components/CardInfo'
import AboutMain from '../components/About/AboutMain'
export default {
  components: {
    CardInfo,
    AboutMain,
    TitlePages
  },
  data () {
    return {
      subTitle: 'Advance Fiber Co. Ltd was established in 2007, in Kanchanaburi, Thailand the home of the legendary Burma Rail.',
      info: 'With over 50 years of operating experience in wood products, we are passionate about the industry, with specialized know-how in the field of wood based products.'
    }
  }
}
